import { EnumPackageType } from './package-type.enum';

export class OverPackagingModel {
  PackageType = EnumPackageType.Overpack;
  Id = '';
  Amount = 1;
  PackingType = '';
  Identification = '';
  Name = '';
}
